import type { FC } from "react";

import { SubscriptionDefaultIcon } from "@jti/brand-icons/subscription-default";
import { useTranslations } from "@jti/ui";

import { ItemFlag } from "@checkout/components/CartItem/ItemFlag/ItemFlag";

export type SubscriptionItemFlagProps = {
  className?: string;
};

export const SubscriptionItemFlag: FC<SubscriptionItemFlagProps> = ({ className }) => {
  const { __ } = useTranslations();

  return (
    <ItemFlag
      icon={SubscriptionDefaultIcon}
      text={__("cart.cart_item.subscription_information")}
      className={className}
    />
  );
};
